// extracted by mini-css-extract-plugin
export default {"card":"ChoiceCard_card__+z0jm"};